import { useEffect, useState } from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';

import { GuestProvider } from './GuestProvider';
import { LanguageProvider } from './LanguageContext';
import { SnackbarProvider } from './SnackbarContext';
import TokenRedirect from './components/TokenRedirect';
import RsvpForm from './rsvp-form/RsvpForm';
import MainPage from './story-components/MainPage';

export default function App() {
  const [mobile, setMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth < 768);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  return (
    <>
      <SnackbarProvider>
        <GuestProvider>
          <LanguageProvider>
            <Router>
              <Routes>
                <Route path="/token/:token" element={<TokenRedirect />} />
                <Route path="/rsvp" element={<RsvpForm />} />
                <Route path="/" element={<MainPage />} />
                <Route path="/schedule" element={<MainPage />} />
                <Route path="/faq" element={<MainPage />} />
                <Route path="/gallery" element={<MainPage />} />
                <Route path="/fun" element={<MainPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Router>
          </LanguageProvider>
        </GuestProvider>
      </SnackbarProvider>
    </>
  );
}
